import { render, staticRenderFns } from "./PlatformCategories.vue?vue&type=template&id=7ba8c3d8&scoped=true"
import script from "./PlatformCategories.vue?vue&type=script&lang=js"
export * from "./PlatformCategories.vue?vue&type=script&lang=js"
import style0 from "./PlatformCategories.vue?vue&type=style&index=0&id=7ba8c3d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba8c3d8",
  null
  
)

export default component.exports